// BNB Address
const BNB_ADDRESS = '0x0cF4071940782b640d0b595Cb17bDf3E90869d70'

export { BNB_ADDRESS }
